import React from 'react';
import { useLocation } from 'react-router-dom';
import { WhatsappLogo } from '@phosphor-icons/react';

const WA_NUMBER = '919910059861';
const WA_TEXT = encodeURIComponent("Hi, I'm interested in building with XceedAgents.ai");

export default function WhatsAppButton() {
  const location = useLocation();
  const onWorkspace = location.pathname.startsWith('/workspace');
  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${WA_TEXT}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-float-button"
      className={`fixed bottom-5 z-[60] group flex items-center ${onWorkspace ? 'right-5 flex-row-reverse' : 'left-5'}`}
    >
      <span
        className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-transform group-hover:scale-110"
        style={{ background: '#25D366' }}
      >
        <WhatsappLogo size={30} weight="fill" color="#fff" />
      </span>
      <span
        className={`px-3 py-1.5 rounded-lg text-sm font-semibold shadow-md opacity-0 pointer-events-none transition-all group-hover:opacity-100 hidden sm:block ${onWorkspace ? 'mr-3 translate-x-2 group-hover:translate-x-0' : 'ml-3 -translate-x-2 group-hover:translate-x-0'}`}
        style={{ background: '#fff', color: '#0B1120' }}
      >
        Chat on WhatsApp
      </span>
    </a>
  );
}
